import { StyledImage } from "./lazyLoadImage.styled";

const Image = (props) => (
    <StyledImage effect="blur" {...props}/>
);

export default Image;
